import { Observation } from "@medplum/fhirtypes";

import { Group, List, Table } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";
import TimeCell, {
  TimeCellVariants,
} from "@/encounters/components/EncounterLabor/EncounterLaborTable/LaborRow/Common/TimeCell";
import { localTimeFromISO } from "@/utils/datetime";

interface BirthDateTimeRowProps {
  showNumbersOnly: boolean;
  observation?: Observation;
  birthDateTime?: string;
  flowsheetId?: string;
  isViewOnly?: boolean;
}

export default function BirthDateTimeRow({
  showNumbersOnly,
  observation,
  birthDateTime: birthDateTimeProp,
  flowsheetId,
  isViewOnly = true,
}: BirthDateTimeRowProps) {
  const birthDateTime = birthDateTimeProp || observation?.valueDateTime || "";

  if (!birthDateTime || showNumbersOnly) return null;

  // Format the birthDateTime to match the time format used by other rows
  const timeStamp = localTimeFromISO(birthDateTime);
  const time = new Date(birthDateTime).toLocaleTimeString();
  const date = new Date(birthDateTime).toLocaleDateString();

  return (
    <Table.Tr bg="white">
      <TimeCell rowSpan={1} time={timeStamp} isViewOnly={true} variant={TimeCellVariants.Gray} />
      <Table.Td p="md" colSpan={10}>
        <TextWrapper size="sm">Birth:</TextWrapper>
        <List fz="sm" withPadding>
          <List.Item>
            <Group gap="xs">
              <TextWrapper size="sm" variant="bold">
                Date:
              </TextWrapper>
              <TextWrapper size="sm">{date}</TextWrapper>
            </Group>
          </List.Item>
          <List.Item>
            <Group gap="xs">
              <TextWrapper size="sm" variant="bold">
                Time:
              </TextWrapper>
              <TextWrapper size="sm">{time}</TextWrapper>
            </Group>
          </List.Item>
        </List>
      </Table.Td>
    </Table.Tr>
  );
}
